import { useState } from 'react'
import Form, { type IChangeEvent } from '@rjsf/core'
import validator from '@rjsf/validator-ajv8'
import {
  payloadSchema,
  PayloadSchemaFormData
} from '../create-schema-modal/CreateSchemaModal'
import type { PayloadSchema } from '../../types/types'
import { useUpdatePayloadSchemaMutation } from '../../hooks/usePayloadSchema'
import { templates, widgets } from '../ui-schema-components'
import { ModalDialog, Mtds, useErrorToast } from 'prove-common'

type EditSchemaModalProps = {
  isOpen: boolean
  setOpen: (isOpen: boolean) => void
  schema: PayloadSchema
}

export const EditSchemaModal = ({
  isOpen,
  setOpen,
  schema
}: EditSchemaModalProps) => {
  const [formData, setFormData] = useState<PayloadSchemaFormData>({
    name: schema.name
  })
  const updatePayloadSchema = useUpdatePayloadSchemaMutation()
  const showError = useErrorToast('oppdatere registreringsskjemaet')
  const onSubmit = async ({
    formData
  }: IChangeEvent<PayloadSchemaFormData>): Promise<void> => {
    if (formData != null) {
      try {
        await updatePayloadSchema.mutateAsync({
          payloadSchemaId: schema.id,
          etag: schema.etag,
          body: {
            schema: schema.schema,
            labId: schema.labId ?? undefined,
            name: formData.name,
            etag: schema.etag
          }
        })
        setOpen(false)
      } catch (error) {
        showError(error)
      }
    }
  }
  return (
    <ModalDialog
      id='edit-schema-modal'
      closedby='any'
      open={isOpen}
      onClose={() => setOpen(false)}
    >
      <Mtds.Button
        command='close'
        commandfor='edit-schema-modal'
        aria-label={'Lukk'}
      />
      <Mtds.Prose>
        <Mtds.Heading>Gi nytt navn til skjemaet</Mtds.Heading>
        <Form
          noHtml5Validate
          formData={formData}
          schema={payloadSchema}
          widgets={widgets}
          templates={templates}
          showErrorList={false}
          validator={validator}
          onChange={(data) => setFormData((prev) => data.formData ?? prev)}
          onSubmit={onSubmit}
        >
          <Mtds.Flex className='mt-8'>
            <Mtds.Button command='close' commandfor='edit-schema-modal'>
              Lukk
            </Mtds.Button>
            <Mtds.Button
              aria-busy={updatePayloadSchema.isPending}
              data-variant='primary'
              disabled={updatePayloadSchema.isPending}
              type='submit'
            >
              Lagre
            </Mtds.Button>
          </Mtds.Flex>
        </Form>
      </Mtds.Prose>
    </ModalDialog>
  )
}
